import { isSilencedByBoundary } from 'settle-ui/components/ContentErrorBoundary/helpers/isSilencedByBoundary/isSilencedByBoundary'

interface IsReactBoundarySilencedErrorParams {
  source: string
  handlingStack: string | undefined
  error: unknown
}

/**
 * True when a RUM console error is React's own re-log of a boundary-caught error that the
 * boundary deliberately handled without reporting — an expected not-found, or a 401 whose
 * `/login` redirect the Apollo error link owns.
 *
 * React logs every boundary-caught error via `console.error` (a `componentDidCatch` frame
 * lands in the capture's handling stack), and RUM ingests that as a duplicate
 * `source: console` error even though the boundary rendered a graceful fallback and skipped
 * its own `logError`. Requiring all three signals — console source, a boundary frame, and a
 * silenced error class — keeps direct `console.error` calls and explicit `logError` reports
 * (`source: custom`) reported.
 *
 * `error` is the original thrown value from the RUM error-event domain context, not the
 * serialized event message.
 */
export const isReactBoundarySilencedError = ({
  source,
  handlingStack,
  error,
}: IsReactBoundarySilencedErrorParams): boolean =>
  source === 'console' && (handlingStack?.includes('componentDidCatch') ?? false) && isSilencedByBoundary(error)
